import type { ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { usePermission } from "@/auth/permissions/usePermission";
import { canAny } from "@/features/feature.types";
import type { RootState } from "@/redux/store";

export function ProtectedRoute({
  permission,
  children,
}: {
  /** A single permission, or a list where holding any one of them is enough. */
  permission?: string | string[];
  children: ReactNode;
}) {
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth?.isAuthenticated ?? false,
  );
  const { can } = usePermission();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (Array.isArray(permission) && permission.length === 0) {
    return <>{children}</>;
  }

  if (!canAny(can, permission)) {
    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
}
